// import React, { useState, useEffect } from "react";

// const Topbar = ({ text, scrollDirection, setScrollDirection }) => {
//   const [lastScrollY, setLastScrollY] = useState(0);

//   // const handleScroll = () => {
//   //   if (window.scrollY > lastScrollY) {
//   //     setScrollDirection("down");
//   //   } else {
//   //     setScrollDirection("up");
//   //   }
//   //   setLastScrollY(window.scrollY);
//   // };

//   const handleScroll = () => {
//     if (window.scrollY > lastScrollY + 50) {
//       setScrollDirection("down");
//     } else if (window.scrollY < lastScrollY - 50) {
//       setScrollDirection("up");
//     }
//     setLastScrollY(window.scrollY);
//   };


//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [lastScrollY, handleScroll]);

//   return (
//     <div
//       className={`w-full h-10 bg-primaryColor hidden lg:flex justify-center items-center transition-all ${scrollDirection === "down" ? "translate-y-[-100%]" : "translate-y-0"
//         } fixed left-0 top-0 right-0 z-50`}
//     >
//       <p className="font-normal text-xs text-whiteColor">{text}</p>
//     </div>
//   );
// };

// export default Topbar;



import React, { useState, useEffect, useCallback } from "react";

const Topbar = ({ text, scrollDirection, setScrollDirection }) => {
  const [lastScrollY, setLastScrollY] = useState(0);

  // useCallback prevents handleScroll from being recreated every render
  const handleScroll = useCallback(() => {
    if (window.scrollY > lastScrollY + 50) {
      setScrollDirection("down");
      setLastScrollY(window.scrollY);
    } else if (window.scrollY < lastScrollY - 50) {
      setScrollDirection("up");
      setLastScrollY(window.scrollY);
    }
  }, [lastScrollY, setScrollDirection]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <div
      className={`w-full h-10 bg-primaryColor hidden lg:flex justify-center items-center 
      transition-transform duration-500 ease-in-out
      ${scrollDirection === "down" ? "-translate-y-full" : "translate-y-0"} 
      fixed left-0 top-0 right-0 z-50`}
    >
      <p className="font-normal text-xs text-whiteColor">{text}</p>
    </div>
  );
};

export default Topbar;
